module.exports = __webpack_public_path__ + "static/media/stockhausen_hbk_15.79f0b480.jpg";